import "bootstrap/dist/css/bootstrap.min.css";
import React, { useEffect } from "react";
import { Card } from "react-bootstrap";

const SBASIntegrityCard = ({ innerRef, plots }) => {
  const renderPlots = () => {
    const imageLabels = [
      {
        label:
          "APV-I Horizontal Stanford diagram with SBAS GEO 123 (HAL = 40 m)",
        imageName: "APV_I_123_H.png",
      },
      {
        label: "APV-I Vertical Stanford diagram with SBAS GEO 123 (VAL = 50 m)",
        imageName: "APV_I_123_V.png",
      },
      {
        label:
          "LPV-200 Horizontal Stanford diagram with SBAS GEO 123 (HAL = 40 m)",
        imageName: "LPV_I_123_H.png",
      },
      {
        label:
          "LPV-200 Vertical Stanford diagram with SBAS GEO 123 (VAL = 35 m)",
        imageName: "LPV_I_123_V.png",
      },
      {
        label:
          "APV-I Horizontal Stanford diagram with SBAS GEO 136 (VAL = 50 m)",
        imageName: "APV_I_136_H.png",
      },
      {
        label: "APV-I Vertical Stanford diagram with SBAS GEO 136 (VAL = 50 m)",
        imageName: "APV_I_136_V.png",
      },
      {
        label:
          "LPV-200 Horizontal Stanford diagram with SBAS GEO 136 (HAL = 40 m)",
        imageName: "LPV_I_136_H.png",
      },
      {
        label:
          "LPV-200 Vertical Stanford diagram with SBAS GEO 136 (VAL = 35 m)",
        imageName: "LPV_I_136_V.png",
      },
    ];

    return (
      <>
        {imageLabels.map((imageLabel, index) => {
          const plot = plots.find(
            (plot) => plot.imageName === imageLabel.imageName
          );
          if (plot) {
            return (
              <React.Fragment key={index}>
                <p className="text-justify">{imageLabel.label}</p>
                <img
                  alt={plot.imageName}
                  src={`data:image/jpeg;base64,${plot.image.data}`}
                />
              </React.Fragment>
            );
          } else {
            return (
              <React.Fragment key={index}>
                <p className="text-danger">No plots available</p>
              </React.Fragment>
            );
          }
        })}
      </>
    );
  };

  return (
    <>
      <Card.Title as="h6" ref={innerRef}>
        Integrity
      </Card.Title>
      <Card.Body>
        <p className="text-justify">
          Integrity is a measure of the trust that can be placed in the
          correctness of the information supplied by the total system. It
          includes the ability of a system to provide timely and valid warnings
          to the user when the system must not be used for the intended
          operation.
        </p>
        <p className="text-justify">
          The Stanford diagrams allow the classification of the samples as
          follows:
        </p>
        <ul>
          <li>
            Normal Operation – when the position error is lower than the
            protection level and they are both lower than the alert limit
          </li>
          <li>
            System unavailable – when the protection level exceeds the alert
            limit
          </li>
          <li>
            MI (misleading information) events – when the position error exceeds
            the protection level
          </li>
          <li>
            HMI (hazardously misleading events) - when the position error
            exceeds the alert limit
          </li>
        </ul>
        {plots && plots.length > 0 ? (
          renderPlots()
        ) : (
          <p className="text-danger">No plots available</p>
        )}
        <p className="text-justify">
          No Misleading Information (MI) or Hazardously Misleading Information
          (HMI) for the reported period.
        </p>
      </Card.Body>
    </>
  );
};

export default React.memo(
  React.forwardRef((props, ref) => (
    <SBASIntegrityCard innerRef={ref} {...props} />
  ))
);
